import { logger } from '@ecosystem/newron-client-lib';
import { feedback } from '@ecosystem/newron-design-system';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppProps } from 'single-spa';
import singleSpaReact from 'single-spa-react';

import { Root } from './root/Root';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err: Error, info: React.ErrorInfo, props: AppProps) {
    logger.error(err, {
      componentStack: info.componentStack,
    });
    return (
      <div className="mx-32 my-16">
        <feedback.Alert type="error">
          An error has occurred within {props.name}. Please refresh your browser, if the error persists please contact
          support for assistance.
        </feedback.Alert>
      </div>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

export { UpsellGuide } from './components';
export { UpsellFeedback } from './components';
export { TargetedUpsell } from './components';
export { NewronUpsell } from './components';
export { Product } from './common';
